import http, { endpoints } from '../http';
import { mapContactFromDto } from './helpers';
const efktClient = http.createClient(endpoints.efkt);
export default class ContactsApi {
    static async listContacts({ accountId, keyword = '', page, limit = 100, }) {
        const response = await efktClient.get('/api/contacts', {
            params: {
                accountId,
                keyword,
                page,
                limit,
            },
        });
        return {
            items: response.data.items.map(mapContactFromDto),
            total: response.data.total,
        };
    }
    /** `GET /api/contact-types` returns a bare JSON array, not the `{ items, total }` envelope. */
    static async getContactTypes() {
        const response = await efktClient.get('/api/contact-types');
        return response.data;
    }
}
